import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ga4 from './lib/ga4';
import reportWebVitals from './reportWebVitals';

if (process.env.REACT_APP_GOOGLE_ANALITICS_ID) {
	ga4.init(process.env.REACT_APP_GOOGLE_ANALITICS_ID as string);
}

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
